var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sparen-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sparen_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 14.000000)",
    stroke: "#263238"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#263238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62984348,19.3348174 C8.62984348,20.1028174 8.00653913,20.7261217 7.23853913,20.7261217 C6.47053913,20.7261217 5.84723478,20.1028174 5.84723478,19.3348174 C5.84723478,18.5668174 6.47053913,17.943513 7.23853913,17.943513 C8.00653913,17.943513 8.62984348,18.5668174 8.62984348,19.3348174",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,5.5 C27,8.537375 24.537375,11 21.5,11 C18.462625,11 16,8.537375 16,5.5 C16,2.462625 18.462625,0 21.5,0 C24.537375,0 27,2.462625 27,5.5 Z",
    id: "Stroke-13",
    strokeWidth: 2.15625,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.3485913,19.2112696 C32.9757217,15.2001391 30.2626783,11.4728348 26.1152,9.48883478 C22.5687652,7.79144348 18.0567652,7.24187826 13.3485913,8.7597913 C8.05189565,10.0759652 5.15102609,14.8690087 5.08841739,14.9399652 C4.73363478,15.3350957 4.36493913,15.7455304 3.98928696,16.1239652 C3.27137391,16.6749217 2.4018087,16.996313 1.49606957,17.0436174 C1.02302609,17.1076174 0.595895652,17.3664 0.319026087,17.7559652 C0.0435478261,18.1455304 -0.0608,18.632487 0.0352,19.1013565 L0.939547826,23.652313 C1.00772174,24.036313 1.37641739,24.3410087 2.03033043,24.7653565 L2.10824348,24.8168348 L4.7072,26.0189217 C4.7072,26.0189217 6.19450435,26.4850087 6.70789565,27.1834435 C6.79972174,27.3128348 6.89850435,27.4366609 7.00702609,27.5632696 C8.47206957,29.0213565 10.5729391,29.5013565 10.5729391,29.5013565 L10.5729391,31.1570087 C10.5729391,32.0794435 11.3200696,32.8251826 12.241113,32.8251826 L16.1353739,32.8251826 C17.7993739,32.8251826 17.8049391,31.7135304 17.8049391,29.6571826 L17.8049391,29.5862261 C18.2710261,29.6070957 18.7357217,29.6293565 19.2045913,29.6460522 C19.4605913,29.6544 19.7138087,29.6571826 19.9642435,29.6571826 C20.3649391,29.6571826 20.7558957,29.6432696 21.1426783,29.6210087 L21.1426783,29.6571826 C21.1426783,31.7135304 21.073113,32.8251826 22.8108522,32.8251826 L26.7065043,32.8251826 C27.6275478,32.8251826 28.3746783,32.0794435 28.3746783,31.1570087 L28.3746783,29.3928348 C31.3228522,27.6022261 33.1969391,24.0794435 33.3805913,20.6345739 C33.3833739,20.5970087 33.3833739,20.5594435 33.3847652,20.520487 L33.3485913,19.2112696 Z",
    id: "Stroke-3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3377104,11.5113764 C16.3377104,11.5113764 21.54258,10.1812895 25.2434495,13.9405938",
    id: "Stroke-9",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(20.790580, 12.611784) rotate(-8.000000) translate(-20.790580, -12.611784) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(5.000000, 9.000000)",
    stroke: "#263238"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M0.00851666667,0.217525 C0.00851666667,0.217525 0.561516667,-0.000641666667 2.79218333,-0.000641666667 C5.02285,-0.000641666667 6.25251667,1.57319167 6.25251667,1.57319167 C6.88135,2.35719167 7.15668333,3.157525 6.82418333,4.158525 C6.28401667,5.38819167 5.08818333,5.97035833 3.87135,5.82335833 C2.14935,5.614525 0.187016667,4.06869167 0.00035,0.217525 L0.00851666667,0.217525 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00851666667,0.217525 C0.00851666667,0.217525 0.561516667,-0.000641666667 2.79218333,-0.000641666667 C5.02285,-0.000641666667 6.25251667,1.57319167 6.25251667,1.57319167 C6.88135,2.35719167 7.15668333,3.157525 6.82418333,4.158525 C6.28401667,5.38819167 5.08818333,5.97035833 3.87135,5.82335833 C2.14935,5.614525 0.187016667,4.06869167 0.00035,0.217525 L0.00851666667,0.217525 Z",
    id: "Stroke-3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sparen-Icon",
    transform: "translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Fr.",
    fontFamily: "Inter-ExtraBold, Inter",
    fontSize: 6,
    fontWeight: 600,
    "line-spacing": 9.5,
    letterSpacing: -0.0750000023,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.3987216,
    y: 7
  }, "Fr.")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparenIcon);
export default __webpack_public_path__ + "static/media/sparen-icon.222f663f.svg";
export { ForwardRef as ReactComponent };